// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__18KuK","content":"ManualTimeModal_content__1zNuX"};